The upper limit of candidate profiles to return from the end of the list.

Defaults to 10.
Excess candidate profiles will be trimmed from the start of the list.
